(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6318],{

/***/ 9797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ EmptyView; },
  "b": function() { return /* reexport */ UnknownErrorView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Seo/index.js + 1 modules
var Seo = __webpack_require__(14934);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/EmptyView/EmptyView.module.scss
var EmptyView_module = __webpack_require__(6493);
var EmptyView_module_default = /*#__PURE__*/__webpack_require__.n(EmptyView_module);
;// CONCATENATED MODULE: ./src/components/EmptyView/EmptyView.jsx







var EmptyView = function() {
    var t = (0,translations/* useTranslation */.$)().t;
    var push = (0,router.useRouter)().push;
    var navigate = (0,react.useCallback)(function() {
        push("/");
    }, [
        push
    ]);
    var title = t("empty_content_view.title");
    var description = t("empty_content_view.text");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                data: {
                    title: title,
                    description: description
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EmptyView_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (EmptyView_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (EmptyView_module_default()).icon,
                            children: "!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                            as: "h1",
                            color: "dark",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                            onClick: navigate,
                            appearance: "outlined",
                            className: (EmptyView_module_default()).button,
                            children: t("empty_content_view.to_home_page")
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/EmptyView/UnknownErrorView.jsx






var UnknownErrorView = function() {
    var t = (0,translations/* useTranslation */.$)().t;
    var reload = (0,router.useRouter)().reload;
    var title = t("empty_content_view.unknown_error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                data: {
                    title: title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (EmptyView_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (EmptyView_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (EmptyView_module_default()).icon,
                            children: "!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                            as: "h1",
                            color: "dark",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                            onClick: reload,
                            appearance: "outlined",
                            className: (EmptyView_module_default()).button,
                            children: t("empty_content_view.reload_page")
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/EmptyView/index.js




/***/ }),

/***/ 67638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ ErrorWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/EmptyView/index.js + 2 modules
var EmptyView = __webpack_require__(9797);
// EXTERNAL MODULE: ./src/components/Layout/index.js + 28 modules
var Layout = __webpack_require__(62569);
;// CONCATENATED MODULE: ./src/components/ErrorWrapper/ErrorWrapper.jsx



var ErrorWrapper = function(param) {
    var children = param.children, error = param.error;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyView/* UnknownErrorView */.b, {})
        });
    }
    return children;
};

;// CONCATENATED MODULE: ./src/components/ErrorWrapper/index.js



/***/ }),

/***/ 16318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ SinglePageTemplate; }
});

// UNUSED EXPORTS: singlePageDataFetcher

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/features/collector/index.js + 4 modules
var collector = __webpack_require__(11871);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
;// CONCATENATED MODULE: ./src/components/templates/SinglePage/SinglePage.fetcher.js






function singlePageDataFetcher(context, options) {
    return _singlePageDataFetcher.apply(this, arguments);
}
function _singlePageDataFetcher() {
    _singlePageDataFetcher = _async_to_generator(regeneratorRuntime.mark(function _callee(context, options) {
        var ref, shouldDebugResponse, locale, query, requestQuery, ref1, data, error, debugData, collectedData;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    shouldDebugResponse = (context === null || context === void 0 ? void 0 : (ref = context.query) === null || ref === void 0 ? void 0 : ref._debugResponse) === "1";
                    locale = context.locale, query = context.query;
                    requestQuery = {
                        slug: query.requestSlug || query.slug
                    };
                    _ctx.next = 7;
                    return fetchSinglePageData({
                        locale: locale,
                        query: requestQuery,
                        debug: shouldDebugResponse
                    }, options);
                case 7:
                    ref1 = _ctx.sent;
                    data = ref1.data;
                    error = ref1.error;
                    debugData = ref1.debugData;
                    _ctx.next = 13;
                    return collectData({
                        items: data.content,
                        context: {
                            slug: query.slug
                        }
                    }, locale);
                case 13:
                    collectedData = _ctx.sent;
                    if (!(error && error.status === 204)) {
                        _ctx.next = 16;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 16:
                    return _ctx.abrupt("return", {
                        props: {
                            data: data,
                            collectedData: collectedData,
                            error: error,
                            debugData: debugData
                        }
                    });
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](0);
                    logError(_ctx.t0, _object_spread({
                        scope: "singlePageDataFetcher"
                    }, context !== null && context !== void 0 ? context : {}, options !== null && options !== void 0 ? options : {}));
                    return _ctx.abrupt("return", {
                        props: {
                            data: {},
                            collectedData: {},
                            error: _ctx.t0,
                            debugData: {
                                error: {
                                    message: _ctx.t0.message,
                                    status: _ctx.t0.status
                                },
                                response: null,
                                scope: "Exception is caught inside during fetching a single page data"
                            }
                        }
                    });
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                19
            ]
        ]);
    }));
    return _singlePageDataFetcher.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ErrorWrapper/index.js + 1 modules
var ErrorWrapper = __webpack_require__(67638);
// EXTERNAL MODULE: ./src/components/Layout/index.js + 28 modules
var Layout = __webpack_require__(62569);
// EXTERNAL MODULE: ./src/components/Seo/index.js + 1 modules
var Seo = __webpack_require__(14934);
// EXTERNAL MODULE: ./src/components/WidgetsRenderer/index.js + 94 modules
var WidgetsRenderer = __webpack_require__(28986);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
;// CONCATENATED MODULE: ./src/components/templates/SinglePage/SinglePage.Template.jsx






var defaultDebugData = {};
function SinglePageTemplate(param) {
    var data = param.data, collectedData = param.collectedData, error = param.error, debugData = param.debugData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapper/* ErrorWrapper */.V, {
        error: error,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageData/* PageDataProvider */.Zz, {
            value: {
                data: data,
                collectedData: collectedData,
                debugData: debugData
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                        data: data.seo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
                        registry: "hero",
                        items: data.hero
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
                        registry: "content",
                        items: data.content
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/templates/SinglePage/index.js




/***/ }),

/***/ 11871:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: collectData

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/features/widgets/widgets.config.js
var widgets_config = __webpack_require__(52853);
;// CONCATENATED MODULE: ./src/features/collector/collector.config.js



var EmptyConfig = null;
var ITEMS_NUMBER = {
    three: 3,
    five: 5
};
var _obj;
var widgetCollectorConfigResolvers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("002"), function(payload) {
    var configs = [];
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("002", payload.id);
    var currentDate = new Date();
    if (payload.events) {
        configs.push({
            entity: "events",
            sort: "eventDate:ASC",
            populate: {
                previewImage: "*",
                eventCategories: {
                    populate: "deep,1"
                }
            },
            filters: {
                active: {
                    $eq: true
                }
            },
            pagination: {
                limit: "7"
            },
            storageKey: "".concat(instanceId, ".events")
        });
    }
    if (payload.articles) {
        configs.push({
            entity: "articles",
            sort: "date:DESC",
            populate: {
                articleCategories: {
                    populate: "deep,1"
                },
                previewImage: {
                    populate: "*"
                }
            },
            filters: {
                date: {
                    $lte: currentDate
                }
            },
            pagination: {
                limit: "14"
            },
            storageKey: "".concat(instanceId, ".articles")
        });
    }
    if (payload.programs) {
        configs.push({
            entity: "courses",
            populate: "deep,1",
            pagination: {
                limit: "7"
            },
            storageKey: "".concat(instanceId, ".courses")
        });
    }
    return configs.length > 0 ? configs : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("012"), function(payload) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("012", payload.id);
    if (payload.contentType === "event") {
        var ref;
        var ref1;
        var eventCategoriesSlug = (ref1 = payload === null || payload === void 0 ? void 0 : (ref = payload.eventCategories) === null || ref === void 0 ? void 0 : ref.map(function(param) {
            var slug = param.slug;
            return slug;
        })) !== null && ref1 !== void 0 ? ref1 : null;
        return eventCategoriesSlug ? {
            entity: "events",
            filters: {
                eventCategories: {
                    slug: {
                        $in: eventCategoriesSlug
                    }
                }
            },
            sort: "eventDate:ASC",
            populate: {
                previewImage: "*"
            },
            fields: [
                "title",
                "slug",
                "eventDate"
            ],
            storageKey: "".concat(instanceId, ".events")
        } : {
            entity: "events",
            sort: "eventDate:ASC",
            pagination: {
                limit: "7"
            },
            fields: [
                "title",
                "slug",
                "eventDate"
            ]
        };
    }
    if (payload.contentType === "article") {
        var ref2;
        var ref3;
        var articlesCategoriesSlug = (ref3 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.articleCategories) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
            var slug = param.slug;
            return slug;
        })) !== null && ref3 !== void 0 ? ref3 : null;
        return articlesCategoriesSlug ? {
            entity: "articles",
            filters: {
                articleCategories: {
                    slug: {
                        $in: articlesCategoriesSlug
                    }
                }
            },
            sort: "date:DESC",
            populate: {
                previewImage: "*"
            },
            fields: [
                "title",
                "slug",
                "date"
            ],
            storageKey: "".concat(instanceId, ".articles")
        } : {
            entity: "articles",
            sort: "date:DESC",
            pagination: {
                limit: "7"
            },
            fields: [
                "title",
                "slug",
                "date"
            ],
            storageKey: "".concat(instanceId, ".articles")
        };
    }
    return EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("027"), function(payload) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("027", payload.id);
    var ref;
    var eventsAmount = (ref = payload === null || payload === void 0 ? void 0 : payload.itemsAmount) !== null && ref !== void 0 ? ref : "three";
    var eventCategories = payload === null || payload === void 0 ? void 0 : payload.eventCategories;
    var ref1;
    var eventCategoriesSlugs = (ref1 = eventCategories === null || eventCategories === void 0 ? void 0 : eventCategories.map(function(param) {
        var slug = param.slug;
        return slug;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var eventsType = (ref2 = payload === null || payload === void 0 ? void 0 : payload.eventType) !== null && ref2 !== void 0 ? ref2 : "active";
    var eventsTypeBoolean = Boolean(eventsType === "active");
    return eventCategoriesSlugs.length > 0 ? {
        entity: "events",
        populate: {
            previewImage: "*",
            eventCategories: {
                populate: "*"
            }
        },
        pagination: {
            limit: ITEMS_NUMBER[eventsAmount]
        },
        sort: "eventDate:ASC",
        filters: {
            eventCategories: {
                slug: {
                    $in: eventCategoriesSlugs
                }
            },
            active: {
                $eq: eventsTypeBoolean
            }
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".events")
    } : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("031", widgets_config/* WIDGETS_REGISTRY.HERO */.R.HERO), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("031", payload.id, widgets_config/* WIDGETS_REGISTRY.HERO */.R.HERO);
    var ref;
    var eventSlug = (ref = context === null || context === void 0 ? void 0 : context.slug) !== null && ref !== void 0 ? ref : null;
    return {
        entity: "events",
        filters: {
            slug: {
                $eq: eventSlug
            }
        },
        populate: {
            previewImage: "*",
            eventCategories: {
                populate: "*"
            },
            request: {
                populate: "*"
            }
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".events")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("058"), function(payload) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("058", payload.id);
    var ref;
    var projectCategories = (ref = payload === null || payload === void 0 ? void 0 : payload.projectCategories.map(function(item) {
        return item.slug;
    })) !== null && ref !== void 0 ? ref : [];
    return {
        entity: "projects",
        fields: [
            "title",
            "description",
            "slug"
        ],
        populate: {
            previewImage: {
                populate: "*"
            }
        },
        filters: {
            projectCategory: {
                slug: {
                    $in: projectCategories
                }
            }
        },
        storageKey: "".concat(instanceId, ".projects")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("064"), function(payload) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("064", payload.id);
    return {
        entity: "courses",
        fields: [
            "title",
            "slug"
        ],
        populate: "deep,1",
        storageKey: "".concat(instanceId, ".courses")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("067"), function(payload) {
    var ref;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("067", payload.id);
    var ref1;
    var eventCategoriesSlugs = (ref1 = (ref = payload.eventCategories) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var slug = param.slug;
        return slug;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var eventsType = (ref2 = payload === null || payload === void 0 ? void 0 : payload.eventType) !== null && ref2 !== void 0 ? ref2 : "active";
    var eventsTypeBoolean = Boolean(eventsType === "active");
    return eventCategoriesSlugs.length > 0 ? {
        entity: "events",
        populate: {
            eventCategories: {
                populate: "*"
            }
        },
        filters: {
            eventCategories: {
                slug: {
                    $in: eventCategoriesSlugs
                }
            },
            active: {
                $eq: eventsTypeBoolean
            }
        },
        sort: "eventDate:DESC",
        fields: [
            "title",
            "slug",
            "eventTimeDescription"
        ],
        storageKey: "".concat(instanceId, ".events")
    } : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("071"), function(payload, context) {
    var configs = [];
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("071", payload.id);
    var currentDate = new Date();
    configs.push({
        entity: "articles",
        populate: {
            articleCategories: {
                populate: "deep,1"
            },
            previewImage: "*"
        },
        filters: {
            articleCategories: {
                slug: {
                    $in: context.slug
                }
            },
            date: {
                $lte: currentDate
            }
        },
        sort: "date:DESC",
        pagination: {
            pagination: {
                page: 1,
                pageSize: 5
            }
        },
        storageKey: "".concat(instanceId, ".articles")
    }, {
        entity: "article-categories",
        disableRequiredFilters: false,
        storageKey: "".concat(instanceId, ".article-categories")
    });
    return configs.length > 0 ? configs : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("072"), function(payload) {
    var configs = [];
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("072", payload.id);
    var currentDate = new Date();
    configs.push({
        entity: "articles",
        populate: {
            articleCategories: {
                populate: "deep,1"
            },
            previewImage: "*"
        },
        filters: {
            date: {
                $lte: currentDate
            }
        },
        sort: "date:DESC",
        pagination: {
            page: 1,
            pageSize: 5
        },
        storageKey: "".concat(instanceId, ".articles")
    }, {
        entity: "article-categories",
        disableRequiredFilters: false,
        storageKey: "".concat(instanceId, ".article-categories")
    });
    return configs.length > 0 ? configs : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("079"), function(payload, context) {
    var ref;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("079", payload.id);
    var ref1;
    var eventCategoriesSlug = (ref1 = (ref = payload.eventCategories) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        return item.slug;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var currentEventSlug = context.slug;
    return eventCategoriesSlug.length > 0 ? {
        entity: "events",
        populate: {
            eventCategories: {
                populate: "*"
            }
        },
        filters: {
            eventCategories: {
                slug: {
                    $in: eventCategoriesSlug
                }
            },
            active: {
                $eq: true
            },
            slug: {
                $ne: currentEventSlug
            }
        },
        sort: "eventDate:ASC",
        pagination: {
            limit: "4"
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".events")
    } : EmptyConfig;
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l012", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var ref;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l012", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var ref1;
    var articlesCategoriesSlug = (ref1 = context === null || context === void 0 ? void 0 : (ref = context.articleCategories) === null || ref === void 0 ? void 0 : ref.map(function(param) {
        var slug = param.slug;
        return slug;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var articleCurrentSlug = context.slug;
    var todayDate = new Date();
    return articlesCategoriesSlug.length > 0 ? {
        entity: "articles",
        filters: {
            articleCategories: {
                slug: {
                    $in: articlesCategoriesSlug
                }
            },
            slug: {
                $ne: articleCurrentSlug
            },
            date: {
                $lte: todayDate
            }
        },
        sort: "date:DESC",
        pagination: {
            limit: "7"
        },
        populate: {
            previewImage: "*"
        },
        fields: [
            "title",
            "slug",
            "date"
        ],
        storageKey: "".concat(instanceId, ".articles")
    } : {
        entity: "articles",
        sort: "date:DESC",
        pagination: {
            limit: "7"
        },
        filters: {
            slug: {
                $ne: articleCurrentSlug
            },
            date: {
                $lte: todayDate
            }
        },
        fields: [
            "title",
            "slug",
            "date"
        ],
        storageKey: "".concat(instanceId, ".articles")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l031", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l031", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var eventSlug = context.slug;
    return {
        entity: "events",
        filters: {
            slug: {
                $eq: eventSlug
            }
        },
        populate: {
            previewImage: "*",
            eventCategories: {
                populate: "*"
            },
            request: {
                populate: "*"
            }
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".events")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l035", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l035", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var courseSlug = context.slug;
    return {
        entity: "courses",
        filters: {
            slug: {
                $eq: courseSlug
            }
        },
        populate: {
            image: "*",
            button: {
                populate: "*"
            }
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".courses")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l066", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l066", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var ref;
    var formTitle = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "subscription";
    return {
        entity: "forms",
        filters: {
            title: {
                $eq: formTitle
            }
        },
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".forms")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l079", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l079", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var currentEventSlug = context.slug;
    return {
        entity: "events",
        populate: {
            eventCategories: {
                populate: "*"
            }
        },
        filters: {
            active: {
                $eq: true
            },
            slug: {
                $ne: currentEventSlug
            }
        },
        pagination: {
            limit: "4"
        },
        sort: "eventDate:ASC",
        fields: [
            "*"
        ],
        storageKey: "".concat(instanceId, ".events")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l081", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l081", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    return {
        entity: "articles",
        populate: {
            previewImage: "*"
        },
        filters: {
            slug: {
                $eq: context.slug
            }
        },
        fields: [
            "title",
            "slug"
        ],
        storageKey: "".concat(instanceId, ".articles")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l082", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l082", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var ref;
    var currentDate = (ref = context === null || context === void 0 ? void 0 : context.date) !== null && ref !== void 0 ? ref : null;
    return {
        entity: "articles",
        populate: {
            previewImage: "*"
        },
        sort: "date:DESC",
        filters: {
            date: {
                $lt: currentDate
            }
        },
        pagination: {
            limit: 1
        },
        fields: [
            "title",
            "slug",
            "date"
        ],
        storageKey: "".concat(instanceId, ".articles")
    };
}), (0,_define_property/* default */.Z)(_obj, (0,widgets/* buildWidgetId */.pz)("l086", widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]), function(payload, context) {
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l086", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var articleSlug = context.slug;
    return {
        entity: "articles",
        populate: {
            articleCategories: {
                populate: "deep,1"
            }
        },
        filters: {
            slug: {
                $eq: articleSlug
            }
        },
        fields: [
            "date"
        ],
        storageKey: "".concat(instanceId, ".articles")
    };
}), _obj);

// EXTERNAL MODULE: ./src/features/logger/logger.utils.js
var logger_utils = __webpack_require__(88953);
;// CONCATENATED MODULE: ./src/features/collector/collector.utils/extractCollectorConfig.js


var extractCollectorConfig = function(items, context) {
    try {
        return items.map(function(item) {
            var configResolver = widgetCollectorConfigResolvers[item.__component];
            if (configResolver) {
                return typeof configResolver === "function" ? configResolver(item, context) : configResolver;
            }
            return EmptyConfig;
        }).flat(1).filter(Boolean);
    } catch (e) {
        (0,logger_utils/* logError */.H)(e, {
            scope: "extractCollectorConfig",
            collection: "-multi-",
            items: items,
            context: context
        });
        return [];
    }
};

;// CONCATENATED MODULE: ./src/features/collector/collector.utils/collectData.js






var collectData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, locale) {
        var items, context, collectorConfig, collectedData, preparedPromises, results;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    items = param.items, context = param.context;
                    collectorConfig = extractCollectorConfig(items, context);
                    collectedData = {};
                    preparedPromises = collectorConfig.map(function(currentConfig) {
                        return (0,cms/* fetchAPI */.I)("/".concat(currentConfig.entity), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentConfig.fields && {
                            fields: currentConfig.fields
                        }, currentConfig.sort && {
                            sort: currentConfig.sort
                        }, currentConfig.pagination && {
                            pagination: currentConfig.pagination
                        }, currentConfig.populate && {
                            populate: currentConfig.populate
                        }), {
                            filters: (0,_object_spread/* default */.Z)({}, currentConfig.filters)
                        }), !currentConfig.disableRequiredFilters && locale);
                    });
                    _ctx.next = 6;
                    return Promise.allSettled(preparedPromises);
                case 6:
                    results = _ctx.sent;
                    results.forEach(function(res, index) {
                        if (res.status !== "fulfilled") {
                            collectedData[collectorConfig[index].storageKey] = [];
                        } else {
                            var ref;
                            var ref1;
                            collectedData[collectorConfig[index].storageKey] = (ref1 = res === null || res === void 0 ? void 0 : (ref = res.value) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : [];
                        }
                    });
                    return _ctx.abrupt("return", collectedData);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function collectData(_, locale) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/collector/collector.utils/index.js


;// CONCATENATED MODULE: ./src/features/collector/index.js



/***/ }),

/***/ 6493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyView_wrapper__s6u5h","content":"EmptyView_content__rVpor","icon":"EmptyView_icon___EFTM","button":"EmptyView_button__i4a_U"};

/***/ })

}]);